import { INITIAL_USER } from "reducers/user";
import { getConfig } from "utils/env";
import { SERVICES } from "utils/onboarding";
import { MERCHANT_ACCOUNT_STATUS } from "./merchantAccount";
import { USER } from "./models";

export const REQUEST_METHOD = {
  GET: "get",
  PUT: "put",
  POST: "post",
  DELETE: "delete"
};

export const MOCK_UUID = "00000000-0000-0000-0000-000000000000";

export const MOCK_MERCHANT_ACCOUNT = {
  id: MOCK_UUID,
  uuid: MOCK_UUID,
  secret_key: "mock_secret_key",
  client_key: getConfig("STRIPE_PUBLISHABLE_KEY"),
  service: SERVICES.STRIPE,
  status: MERCHANT_ACCOUNT_STATUS.ACTIVE,
  merchant_account_config: {
    id: MOCK_UUID,
    uuid: MOCK_UUID,
    merchant_account_id: MOCK_UUID,
    data: {
      common: {
        checkout_fee_percent: 0,
        application_fee_percent: 0,
        cancel_url: "",
        success_url: ""
      },
      pricing: {
        common: {
          trial_period_days: 0
        }
      },
      product: {
        common: {}
      }
    }
  },
  account: {
    id: "mock_account_id",
    object: "account",
    capabilities: {
      afterpay_clearpay_payments: "active",
      bancontact_payments: "active",
      card_payments: "active",
      eps_payments: "active",
      giropay_payments: "active",
      ideal_payments: "active",
      p24_payments: "active",
      sepa_debit_payments: "active",
      sofort_payments: "active",
      transfers: "active"
    },
    charges_enabled: true,
    country: "US"
  }
};

export const MOCK_APPLICATION = {
  id: MOCK_UUID,
  uuid: MOCK_UUID,
  subdomain: getConfig("APP_SUBDOMAIN"),
  merchant_account_id: MOCK_UUID,
  routes: {
    "/pricing": {
      status: "active",
      variations: [
        {
          weight: 100,
          deployment: "",
          manifest: ""
        }
      ]
    }
  }
};

const MOCK_MODEL = {
  id: MOCK_UUID,
  uuid: MOCK_UUID
};

export const MOCK_REFERENCES = {
  resource: USER,
  resourceID: MOCK_UUID,
  resourceUUID: MOCK_UUID,
  user: {
    ...INITIAL_USER,
    ...MOCK_MODEL
  },
  merchantAccount: MOCK_MERCHANT_ACCOUNT,
  application: MOCK_APPLICATION
};

export const TEST_PARAMS = { test: true };
